import React from "react";
import { Input, Divider } from "antd";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";

const { TextArea } = Input;

const WrittenFeedback = ({ recordData, mode }) => {
  const fields = [
    {
      name: "strengths",
      label: "Key Strengths",
      placeholder:
        "Highlight the employee's key strengths and positive contributions during this review period...",
      description:
        "Focus on specific examples and achievements that demonstrate their strengths.",
    },
    {
      name: "improvements",
      label: "Areas for Development",
      placeholder:
        "Identify areas where the employee can develop and grow their skills...",
      description:
        "Be constructive and specific about opportunities for growth and development.",
    },
    {
      name: "goals",
      label: "Goals for Next Period",
      placeholder:
        "Set specific, measurable goals for the next review period...",
      description:
        "Set SMART goals (Specific, Measurable, Achievable, Relevant, Time-bound).",
    },
    {
      name: "comments",
      label: "Additional Comments",
      placeholder:
        "Any additional comments, notes, or context for this review...",
    },
  ];

  return (
    <div>
      {fields.map((field, index) => (
        <React.Fragment key={field.name}>
          <div className="w-full">
            {mode === "view" ? (
              <>
                <div className="font-medium title-text text-base">{field.label}</div>
                <p className="muted-text p-2 text-[14px]">
                  {recordData?.pfr_result?.[field.name] || "-"}
                </p>
              </>
            ) : (
              <>
                <FormItem
                  className="font-medium mb-2"
                  name={field.name}
                  label={field.label}
                  rules={
                    field.name === "comments" ? [] : [requiredField]
                  }
                >
                  <TextArea
                    id={field.name}
                    className="input-field"
                    maxLength={255}
                    placeholder={field.placeholder}
                  />
                </FormItem>

                {field.description && (
                  <p className="text-[11px] mt-2 mb-4 muted-text">
                    {field.description}
                  </p>
                )}
              </>
            )}
          </div>

          {index < fields.length - 1 && <Divider className="my-4" />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default WrittenFeedback;
